<template>
    <Button class="ButtonIcon" v-bind="$attrs" :to="to" :href="href" @click="$emit('click')">
        <Icon :name="icon"/>
        <span>
            <slot></slot>
        </span>
    </Button>
</template>

<script>
export default {
    name: 'ButtonIcon',
    inheritAttrs: false,

    props: {
        icon: { type: String, required: true },
        to: { type: String, default: '' },
        href: { type: String, default: '' },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ButtonIcon {
    .Icon, span {
        display: inline-block;
        vertical-align: middle;
    }

    .Icon {
        margin-right: 10px;
    }
}
</style>
